(function () {
    'use strict';

    // @ngInject
    Services.Branch = function Branch($window, Gon, $q, ThirdPartyLoaderService) {
        // we load this on the angular side, but after everything finished loading so we only use this to promisify the sdk
        return ThirdPartyLoaderService.loadCallbackPromise(function() {}, function() {return $window.branch;})
            .then(function(branchSdk) {
                $window.branch.init(Gon.branch_api_key);
                return $q.resolve(branchSdk);
            });
    };

}());
